goog.provide("shadow.js.shim.module$src$svg$shapes$rectangle$rectangle_split_3x1_svg$default");
shadow.js.shim.module$src$svg$shapes$rectangle$rectangle_split_3x1_svg$default = shadow.js.shim.module$src$svg$shapes$rectangle$rectangle_split_3x1_svg.default;
